import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/popcard/PRODUCTION/getpopcard.com/components/pages-container/AcheterMaPopcard.tsx");
